/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StepBackwardIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Step Backward',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m9.74902,15.95508c-.39404,0-.78711-.10645-1.14453-.31738l-6.25439-3.70117c-.69189-.40918-1.10449-1.13281-1.10449-1.93652s.4126-1.52734,1.10449-1.93652l6.25439-3.70117c.70508-.41602,1.55029-.42188,2.26025-.01758.71094.40625,1.13525,1.13574,1.13525,1.9541v7.40234c0,.81836-.42432,1.54785-1.13525,1.9541-.3501.19922-.7334.2998-1.11572.2998Zm-.00391-10.4082c-.11328,0-.24219.02734-.37695.10645l-6.25439,3.70117c-.33252.19629-.36816.5166-.36816.64551s.03564.44922.36816.64551l6.25439,3.70117c.3374.2002.63965.07031.75342.00586.11377-.06543.37842-.25879.37842-.65137v-7.40234c0-.39258-.26465-.58594-.37842-.65137-.06836-.03906-.20508-.10059-.37646-.10059Z"
      fill="currentColor"
    />
    <path
      d="m16.75,16h-.5c-1.24072,0-2.25-1.00977-2.25-2.25v-7.5c0-1.24023,1.00928-2.25,2.25-2.25h.5c1.24072,0,2.25,1.00977,2.25,2.25v7.5c0,1.24023-1.00928,2.25-2.25,2.25Zm-.5-10.5c-.41357,0-.75.33691-.75.75v7.5c0,.41309.33643.75.75.75h.5c.41357,0,.75-.33691.75-.75v-7.5c0-.41309-.33643-.75-.75-.75h-.5Z"
      fill="currentColor"
    />
  </svg>`;
};
